import { Color } from '../../utils/CommonGrid';

export const getVersionConfig = () => {
  const version = process.env.REACT_APP_RELEASE_VERSION || 'v253';
  const suffix = version === 'v254' ? '_v254' : '';
  return { version, suffix };
};

export const getHeaderProps = () => ({ style: Color });

export const getCategoryByTab = tab => {
  switch (tab) {
    case 'GDA':
      return 'GDA';
    case 'VDA':
      return 'VDA';
    case 'DISEASES':
      return 'Disease';
    case 'GENES':
      return 'Gene';
    case 'VARIANTS':
      return 'Variant';
    case 'CHEMICALS':
      return 'Chemical';
    default:
      return null;
  }
};

export const shouldShowFeature = (featureName, groups, isAuthenticated) => {
  if (featureName === 'SCORE_BUTTON') {
    const isAcademic = groups?.includes('ROLE_ACADEMIC');
    return !isAcademic && isAuthenticated;
  }
  return process.env[`REACT_APP_SHOW_${featureName}`] === 'true';
};
